import React, { useState, Component, Fragment } from "react";
import "./widget.scss";
import SpanMoreTabDown from "../../images/chevron-down-small.svg";
import SpanMoreTabTop from "../../images/chevron-top.svg";
import { Accordion, Card } from "react-bootstrap";
import { useAccordionToggle } from "react-bootstrap/AccordionToggle";
import MoneyLogo1 from "../../images/money-1.svg";
import MoneyLogo2 from "../../images/money-2.svg";
import MoneyLogo3 from "../../images/money-3.svg";
import MoneyLogo4 from "../../images/money-4.svg";
import MoneyLogo5 from "../../images/money-5.svg";
import CoverDetails from "../CoverDetailsModal";
import { CurrencyUtils } from "../../utils";

function CustomToggle({ init, children, eventKey, defaultToggle }) {
  const decoratedOnClick = useAccordionToggle(eventKey);
  const [toggle, setToggle] = useState(defaultToggle);

  const onToggle = e => {
    e.stopPropagation();
    setToggle(!toggle);
    decoratedOnClick();
  };

  const forceAction = toggleValue => {
    if (!toggle) {
      setToggle(toggleValue);
      decoratedOnClick();
    }
  };

  if (init) {
    init(forceAction);
  }

  return (
    <Card.Header name="toggle" onClick={e => onToggle(e)}>
      <img
        src={toggle ? SpanMoreTabTop : SpanMoreTabDown}
        width="24px"
        height="24px"
        alt="span image"
        style={{ marginRight: "4px" }}
      />
      {children}
    </Card.Header>
  );
}

export default class WidgetComponent extends Component {
  state = {
    selected: null,
    more: false,
    planPrice: ""
  };
  callBackAction;

  constructor(props) {
    super(props);
  }

  _onChangePlan = async value => {
    const { onChangePlan, selected } = this.props;
    if (onChangePlan) {
      onChangePlan(value);
      if (value !== selected) {
        this.callBackAction(1);
      }
    }
  };

  _getLogo(index) {
    const icon =
      index === 1
        ? MoneyLogo1
        : index === 2
        ? MoneyLogo2
        : index === 3
        ? MoneyLogo3
        : index === 4
        ? MoneyLogo4
        : MoneyLogo5;

    return <img src={icon} width="40px" height="40px" alt="icon" />;
  }

  _onToggleInit = callBackAction => {
    if (callBackAction) {
      this.callBackAction = callBackAction;
    }
  };
  // showModal = index => {
  //   this.setState({ selectedPackage: index });
  //   this.setState({ show: true });
  // };
  // hideModal = () => {
  //   this.setState({ show: false });
  // };
  render() {
    const {
      selected,
      listItem,
      index,
      counter = 1,
      defaultToggle = false,
      usertype = 1
    } = this.props;
    const {
      id,
      packageCode,
      logo,
      title,
      insured,
      price,
      stamp,
      vat,
      total
    } = listItem;
    // const { showModal } = this.props;
    let totalAmount = total
    if (usertype != 2) {
      totalAmount = counter ? total * counter : total;
    }
    // console.log("widget OpenModal:", showModal);
    // const { show, selectedPackage } = this.state;
    return (
      <Fragment>
        <div className="form-group">
          <div
            className="widget-wrapper"
            onClick={() => this._onChangePlan(id)}
          >
            <div className={`widget-radio ${selected === id ? "active" : ""}`}>
              <div className="radio" />
            </div>
            <div className="d-flex flex-column flex-1">
              <div className="d-flex">
                {this._getLogo(index)}
                <div className="d-flex flex-column">
                  <p className="title">{title}</p>
                  <p className="value">
                    {CurrencyUtils.commaFormat(insured)} บาท
                  </p>
                </div>
              </div>
              {/* <PlanDetail className="font-weight" detail="ทุนประกัน" price={insured} />  activeKey={selected} */}
              <Card className="accordion-item">
                {/* <Accordion className="accordion-widget-wrapper"> */}
                <div className="d-flex align-item-center">
                  <CustomToggle
                    className="accordion-toggle"
                    defaultToggle={defaultToggle}
                    eventKey={id}
                    init={this._onToggleInit}
                  >
                    <span className="text-dark-blue" name="toggle">
                      เบี้ยประกันภัยรวม
                    </span>
                  </CustomToggle>
                  <p className="ml-auto text-total-amount">
                    {CurrencyUtils.currency(totalAmount)} บาท
                  </p>
                </div>

                <Accordion.Collapse eventKey={id}>
                  <Card.Body className="accordion-collapse">
                    {/* <div className="content" dangerouslySetInnerHTML={{__html: thisIsMyCopy}}></div> */}
                    <PlanDetail
                      detail="เบี้ยประกันภัยสุทธิ"
                      price={CurrencyUtils.currency(price)}
                      userType={usertype}
                    />
                    <PlanDetail
                      detail="อากรแสตมป์"
                      price={CurrencyUtils.currency(stamp)}
                      userType={usertype}
                    />
                    <PlanDetail
                      detail="ภาษีมูลค่าเพิ่ม"
                      price={CurrencyUtils.currency(vat)}
                      userType={usertype}
                    />
                    <PlanDetail
                      className="text-blue font-bold"
                      detail="เบี้ยประกันภัยรวม"
                      price={CurrencyUtils.currency(total)}
                      userType={usertype}
                    />
                  </Card.Body>
                </Accordion.Collapse>
                <u
                  className="text-blue ml-auto mt-2"
                  onClick={this.props.showModal}
                >
                  รายละเอียดความคุ้มครอง
                </u>
                {/* </Accordion> */}
              </Card>
            </div>
          </div>
        </div>
        {/* <CoverDetails
          show={show}
          hideModal={this.hideModal}
          listItem={listItem}
          insurance_type={"ประกันอุบัติเหตุ"}
          productCode={"MTI06113"}
          selectedPackage={selectedPackage}
          custOrder={"1"}
        /> */}
      </Fragment>
    );
  }
}

const PlanDetail = ({ className = "", detail, price, isBold, userType = 1 }) => {
  const priceText = isBold ? <b>{price} บาท</b> : `${price} บาท`;
  return (
    <div className={`d-flex detail ${className}`}>
      <span>{detail}{userType == 1 && 'ต่อ 1 ท่าน'}</span>
      <span className="ml-auto price">{priceText}</span>
    </div>
  );
};
